import DataSkriningRisikoJatuh from "@/services/DataSkriningRisikoJatuh";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";

let risikoJatuhRegister: string = null;
let risikoJatuhToken = 0;
let riwayatRm: string = null;
let riwayatToken = 0;

@Module({ store, dynamic: true, name: "storeSkriningRisikoJatuh" })
class StoreSkriningRisikoJatuh extends VuexModule {
  risikoJatuh = null;
  skriningRisikoJatuh = {};
  riwayatSkrining = [];

  // @Mutation SET_SKRINING_RISIKO_JATUH(skriningRisikoJatuh: {}) {
  //   this.skriningRisikoJatuh = skriningRisikoJatuh;
  // }
  @Mutation SET_RISIKO_JATUH_REG(risikoJatuh) {
    this.risikoJatuh = risikoJatuh;
  }
  @Mutation SET_RIWAYAT_SKRINING(riwayatSkrining = []) {
    this.riwayatSkrining = riwayatSkrining;
  }
  @Mutation CLEAR_STORE() {
    this.risikoJatuh = null;
    this.skriningRisikoJatuh = {};
    this.riwayatSkrining = [];
  }

  // @Action actSkriningRisikoJatuh(param) {
  //   const dt = DataSkriningRisikoJatuh.getDataAsesmenRisikoJatuh(param["unit_id"], param["reg"]);
  //   // appModule.setLoading(true);
  //   dt.then(dt => {
  //     // appModule.setLoading(false);
  //     const detail = dt.data;
  //     this.SET_SKRINING_RISIKO_JATUH(detail);
  //   });
  // }

  @Action actRisikoJatuhByUnitAndReg(param: { unit_id: string; reg: string }) {
    const { unit_id, reg } = param;
    const key = `${unit_id}:${reg}`;
    const token = ++risikoJatuhToken;

    if (risikoJatuhRegister !== key) {
      this.SET_RISIKO_JATUH_REG(null);
    }
    risikoJatuhRegister = key;

    const dt = DataSkriningRisikoJatuh.getDataSkriningRisikoJatuhByReg(
      unit_id,
      reg
    );
    dt.then(dt => {
      if (token !== risikoJatuhToken) return;

      const list = Array.isArray(dt?.data) ? dt.data : [];
      const data = list.find(item => item.unit_id == unit_id);

      this.SET_RISIKO_JATUH_REG(data ?? null);
    });
  }

  @Action actRisikoJatuhByRm(rm) {
    const token = ++riwayatToken;

    if (riwayatRm !== String(rm)) {
      this.SET_RIWAYAT_SKRINING([]);
    }
    riwayatRm = String(rm);

    appModule.setLoading(true);

    const dt = DataSkriningRisikoJatuh.getDataSkriningRisikoJatuhByRm(rm);
    dt.then(dt => {
      appModule.setLoading(false);
      if (token !== riwayatToken) return;

      this.SET_RIWAYAT_SKRINING(Array.isArray(dt?.data) ? dt.data : []);
    });
  }

  @Action reset() {
    risikoJatuhRegister = null;
    riwayatRm = null;
    risikoJatuhToken++;
    riwayatToken++;
    this.CLEAR_STORE();
  }
}

export const storeSkriningRisikoJatuh = getModule(StoreSkriningRisikoJatuh);
